module.exports = __webpack_public_path__ + "img/team-member-02.b66bb1b1.jpg";